import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import CuisineInterface from "./CuisineInterface";
import { apiFetch } from "../utils/apiClient";
import { showToast } from "../utils/toast";

const GenericKdsInterface = () => {
  const { destination: rawDestination } = useParams();
  const destination = String(rawDestination || "").trim().toLowerCase();
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  const [unavailableReason, setUnavailableReason] = useState("");

  const loadConfig = useCallback(async ({ silent = false } = {}) => {
    if (!destination) return;
    if (!silent) setLoading(true);
    try {
      const response = await apiFetch("/api/production-destinations", {
        cache: "no-store",
      });
      const rows = await response.json().catch(() => []);
      if (!response.ok) throw new Error("Impossible de charger les destinations KDS");
      const next = (Array.isArray(rows) ? rows : []).find(
        (entry) => String(entry?.code || "") === destination,
      );
      const isAvailable =
        next &&
        Boolean(Number(next?.is_active ?? 1)) &&
        Boolean(Number(next?.kds_enabled ?? 0));
      if (!isAvailable || ["none", "cuisine", "bar"].includes(destination)) {
        const message = "Cette destination KDS est introuvable ou désactivée.";
        setConfig(null);
        setUnavailableReason(message);
        if (silent) showToast("info", message);
        return;
      }
      setUnavailableReason("");
      setConfig(next);
    } catch (error) {
      setUnavailableReason(error?.message || "Impossible de charger le KDS");
      showToast("error", error?.message || "Impossible de charger le KDS");
    } finally {
      if (!silent) setLoading(false);
    }
  }, [destination]);

  useEffect(() => {
    void loadConfig();
  }, [loadConfig]);

  if (!config) {
    return (
      <main className="moo-app-screen min-h-screen bg-slate-950 text-white flex items-center justify-center p-6">
        <div className="rounded-3xl border border-white/10 bg-white/5 px-8 py-7 text-center">
          <h1 className="text-2xl font-bold">{loading ? "Chargement du KDS…" : "KDS indisponible"}</h1>
          <p className="mt-2 text-white/65">
            {loading
              ? "Préparation de l’écran de production."
              : unavailableReason || "Vérifiez la destination dans les paramètres."}
          </p>
        </div>
      </main>
    );
  }

  return (
    <CuisineInterface
      key={config.code}
      destinationCode={config.code}
      destinationName={config.name}
      destinationConfig={config}
      onDestinationConfigUpdated={() => loadConfig({ silent: true })}
    />
  );
};

export default GenericKdsInterface;
